import { configureStore } from '@reduxjs/toolkit'

import { api } from './api/api'
import { rtkErrorHandler } from './api/apiMiddleware'
import agentReducer from './features/agent/agentSlice'
import chatReducer from './features/chats/chatSlice'
import { copilotMiddleware } from './features/copilot/copilotMiddleware'
import copilotReducer from './features/copilot/copilotSlice'
import streamingChatReducer from './features/copilotv2/ChatSlice'
import layoutReducer from './features/layoutSlice'
import memoryReducer from './features/memory/memorySlice'
import projectReducer from './features/project/projectSlice'

// Create a variable to hold the store instance
let storeInstance: AppStore | undefined

export const makeStore = () => {
  const store = configureStore({
    reducer: {
      chat: chatReducer,
      streamingChat: streamingChatReducer,
      memory: memoryReducer,
      agent: agentReducer,
      project: projectReducer,
      layout: layoutReducer,
      copilot: copilotReducer,
      [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: ['copilot/connect', 'copilot/sendMessage'],
        },
      }).concat(copilotMiddleware, api.middleware, rtkErrorHandler),
  })

  // Save the store instance
  storeInstance = store

  // Expose the store to the window object in development
  if (typeof window !== 'undefined') {
    ;(window as any).__REDUX_STORE__ = store
  }

  return store
}

// Function to get the store instance
export const getStore = () => storeInstance

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
